import * as React from 'react';
import { ConfigContext } from '../config-provider';
/* istanbul ignore next */
export default function genPurePanel(Component) {
    return function PurePanel(props) {
        const { prefixCls: customizePrefixCls, style } = props;
        const holderRef = React.useRef(null);
        const [popupHeight, setPopupHeight] = React.useState(0);
        const [open, setOpen] = React.useState(false);
        const { getPrefixCls } = React.useContext(ConfigContext);
        const prefixCls = getPrefixCls('select', customizePrefixCls);
        React.useEffect(() => {
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver(entries => {
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                });
                const interval = setInterval(() => {
                    var _a;
                    const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.${prefixCls}-dropdown`);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return () => {
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, []);
        return (React.createElement("div", { ref: holderRef, style: { paddingBottom: popupHeight } },
            React.createElement(Component, Object.assign({}, props, { style: Object.assign(Object.assign({}, style), { margin: 0 }), open: open, getPopupContainer: () => holderRef.current }))));
    };
}
